/** @jsx jsx */

import { useState, useEffect, Fragment as _, useContext } from 'react';

import { css, jsx } from '@emotion/core';
import { interactionContext } from './interactionContext';
import getBlockById from 'services/apiHelpers/getBlockById';
import setBlockProps from 'services/apiHelpers/setBlockProps';
import { getButtonFocus } from 'styles/variables';
import fa_check from 'assets/fa-check.svg';

const Tick = ({ tickColor }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path
        fill={`${tickColor}`}
        d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
      />
    </svg>
  );
};

const TermsAndConditions = ({ size = 15, onClick = null, ...props }) => {
  const context: any = useContext(interactionContext);
  const { id } = props;

  const {
    accept,
    acceptContent = 'e.g. I accept these terms and conditions.',
    acceptBorderRadius = 0,
    acceptTextColor = undefined,
    acceptBackgroundColor = undefined,
    lockDown,
  } = context.props;

  //
  const [toggle, setToggle] = useState(lockDown === 0 ? true : false);

  const tickColor = acceptTextColor || '#000';

  useEffect(() => {
    if (toggle) {
      setBlockProps(getBlockById(context.id), { lockDown: 0 });
    }
  }, [toggle]);

  return accept ? (
    <form onSubmit={e => e.preventDefault()}>
      <div
        css={css`
          position: relative;
          display: inline-flex;
          align-items: center;
          margin: 20px 0 0 0;
          padding: ${acceptBackgroundColor ? '10px' : '10px 0 10px 0'};
          border-radius: ${acceptBorderRadius}px;
          background: ${acceptBackgroundColor};
          cursor: pointer;
          ${(window.dev() || toggle) && 'pointer-events: none;'}

          &:focus {
            ${getButtonFocus(acceptBackgroundColor || tickColor)}
          }
        `}
        onClick={() => {
          setToggle(true);
        }}
        onKeyUp={
          window.dev()
            ? () => {}
            : (e: any) => {
                console.log(e);
                if ([' ', 'Enter'].includes(e.key)) {
                  setToggle(true);
                }
              }
        }
        tabIndex={!toggle ? 0 : -1}
      >
        <input
          id={`i${id}`}
          type="checkbox"
          value={`i${id}`}
          name={`i${id}`}
          checked={toggle}
          readOnly
          css={css`
            position: absolute;
            left: 0;
            top: 0;
            opacity: 0;
          `}
          tabIndex={-1}
        />
        <label
          htmlFor={`i${id}`}
          css={css`
            color: ${acceptTextColor};
            pointer-events: none;
          `}
          tabIndex={-1}
        >
          {acceptContent}
        </label>

        <div
          css={css`
            display: inline-flex;
            justify-content: center;
            align-items: center;
            width: ${size}px;
            height: ${size}px;
            margin: 0 0 0 10px;
            padding: 2px;
            border: 1px solid ${acceptTextColor || 'lightGrey'};
          `}
        >
          {/* <i
            className="fa fa-check"
            css={css`
              color: ${window.dev() || toggle ? tickColor : 'rgba(0, 0, 0, 0)'};
              font-size: 9px;
            `}
          /> */}

          {/* <img
            src={fa_check}
            css={css`
               {
                width: 16px;
                height: 16px;
              }
            `}
          /> */}

          <Tick
            tickColor={window.dev() || toggle ? tickColor : 'rgba(0, 0, 0, 0)'}
          />
        </div>
      </div>
    </form>
  ) : null;
};

export default TermsAndConditions;
